import { http } from '@pendo/http';
import moment from '@utils/moment-wrapper';

export async function getSyncStatus (kind = 'visitor') {
    return http.get(`/api/s/_SID_/synctime/journal${kind}tagmembership`).then((res) => res.data);
}

/* Check any pending journal jobs to ensure they have completed since last CSV
   upload so we can confidently assert that the entity tag list is accurate */
export async function checkIfCsvTimestampBeforeLastSync (timestamp, kind = 'visitor') {
    try {
        const status = await getSyncStatus(kind);
        const { SyncedThrough } = status;

        return moment(SyncedThrough).isAfter(moment(timestamp));
    } catch (error) {
        throw error;
    }
}

export async function validateDelayedAnalyticsWithSegmentFilters (filters) {
    let delayedAnalytics = false;
    const delayedKinds = {};
    const checkForDelayedAnalytics = (filters) => {
        const analyticsDelayedTimestamps = [];
        filters.forEach((rule) => {
            if (rule.or) {
                analyticsDelayedTimestamps.push(...checkForDelayedAnalytics(rule.or));
            } else {
                const { analyticsDelayedAtTimestamp: delay, kind } = rule;
                if (delay) {
                    analyticsDelayedTimestamps.push(delay);
                    delayedKinds[kind] = true;
                }
            }
        });

        return analyticsDelayedTimestamps;
    };

    const delays = checkForDelayedAnalytics(filters).sort();
    if (delays.length) {
        const lastDelay = delays.pop();

        for (const kind of Object.keys(delayedKinds)) {
            if (delayedAnalytics) return;
            const synced = await checkIfCsvTimestampBeforeLastSync(lastDelay, kind); // eslint-disable-line no-await-in-loop
            delayedAnalytics = !synced;
        }
    }

    return delayedAnalytics;
}
